module.exports = __webpack_public_path__ + "static/media/yellow_right_arrow.e34f5842.webp";